import { ref, onMounted, onUnmounted } from 'vue'
import { useAuthStore } from '@/stores/auth'

export function useTokenRefresh() {
  const authStore = useAuthStore()
  const refreshInterval = ref(null)
  
  // Refresh token 5 minutes before expiration (55 minutes for 1-hour tokens)
  const REFRESH_INTERVAL = 55 * 60 * 1000 // 55 minutes in milliseconds
  
  const startTokenRefresh = () => {
    if (!authStore.accessToken) return
    
    // Clear any existing interval
    if (refreshInterval.value) {
      clearInterval(refreshInterval.value)
    }
    
    // Set up automatic token refresh
    refreshInterval.value = setInterval(async () => {
      if (authStore.isLoggedIn) {
        try {
          await authStore.refreshAccessToken()
        } catch (error) {
          console.error('Automatic token refresh failed:', error)
          // Token refresh failed, user needs to login again
          authStore.logout()
        }
      } else {
        // User is not logged in, clear interval
        stopTokenRefresh()
      }
    }, REFRESH_INTERVAL)
  }
  
  const stopTokenRefresh = () => {
    if (refreshInterval.value) {
      clearInterval(refreshInterval.value)
      refreshInterval.value = null
    }
  }
  
  // Start token refresh when composable is used
  onMounted(() => {
    if (authStore.isLoggedIn) {
      startTokenRefresh()
    }
  })
  
  // Clean up on unmount
  onUnmounted(() => {
    stopTokenRefresh()
  })
  
  return {
    startTokenRefresh,
    stopTokenRefresh
  }
}